import Link from 'next/link';
import { getDirectImageUrl, getImageBuilder } from '@/app/lib/media-helper';
import { cn } from '@/app/lib/utils';
import type { IFooterLogo as FooterLogoType } from '../interfaces';
import { shouldOpenInNewTab } from '../lib/footer.utils';

export interface FooterLogoProps {
  imageUrl?: string;
  bynderLogo?: any;
  title?: string;
  link?: FooterLogoType['link'];
  className?: string;
}

export const FooterLogo = ({ imageUrl, bynderLogo, title, link, className = '' }: FooterLogoProps) => {
  const resolvedImageUrl =
    imageUrl ||
    getDirectImageUrl(bynderLogo) ||
    (bynderLogo ? getImageBuilder(bynderLogo).width(126).dpr(1).url() : undefined);
  if (!resolvedImageUrl) return null;

  const logoImage = (
    <img
      src={resolvedImageUrl}
      alt={title || 'Footer Logo'}
      className="h-auto cursor-pointer"
      width={126}
      height={30}
    />
  );

  if (link?.url) {
    const openInNewTab = shouldOpenInNewTab(link);

    return (
      <Link
        href={link.url}
        target={openInNewTab ? '_blank' : '_self'}
        rel={openInNewTab ? 'noopener noreferrer' : undefined}
        className={cn('flex items-start justify-start', className)}
      >
        {logoImage}
      </Link>
    );
  }

  return <div className={cn('flex items-start justify-start', className)}>{logoImage}</div>;
};
